<template>
	<TopTab />
	<div>
		<router-view />
	</div>
</template>

<script setup>
import TopTab from '@/views/workbench/personal/TopTab.vue'
</script>

<style lang="scss" scoped>

</style>
